<template>
    <div>
        <ActivityModal v-if="isOpen" class="ChatThreadsBar" :items="threads" @close="close">
            <template slot="title">
                Samtaler
            </template>

            <template slot="empty">
                Du har endnu ingen samtaler.
            </template>

            <div slot="item" slot-scope="{ item }">
                <ActivityModalItem
                    :avatar="item.participants[0].user ? item.participants[0].user.avatar_url : null"
                    :date="getDate(item)"
                    :title="isBrand ? getTitleCombined(item) : getTitle(item)"
                    :body="getExcerpt(item)"
                    :unread="item.unread_count > 0"
                    :action-text="'Se samtale'"
                    action-url="#"
                    @click.native.prevent="openChat(item.id)"
                />
            </div>
        </ActivityModal>

        <ChatModal
            v-if="currentModal === 'chat'"
            v-bind="currentModalParams"
            :open-instantly="true"
            @closed="closeModal"
        />

        <slot :open="open" :unread="unreadCount"></slot>
    </div>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';
</style>

<script type="text/babel">
import { ReplaySubject } from 'rxjs'
import { skip, take } from 'rxjs/operators'
import ActivityModal from 'dashboard-js/components/ActivityModal'
import ActivityModalItem from 'dashboard-js/components/ActivityModalItem'
import ChatModal from 'dashboard-js/components/chat/ChatModal'
import ChatProvider from 'dashboard-js/providers/ChatProvider'
import UserProvider from 'dashboard-js/providers/UserProvider'
import CreatesPopovers from 'dashboard-js/mixins/CreatesPopovers'
import HasSubscriptions from 'dashboard-js/mixins/HasSubscriptions'
import ManagesModalState from 'dashboard-js/mixins/ManagesModalState'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'

export default {
    components: {
        ActivityModalItem,
        ChatModal,
        ActivityModal,
    },

    mixins: [CreatesPopovers, HasSubscriptions, ManagesModalState, RestoreOnPageBack],

    data() {
        return {
            isOpenStream: new ReplaySubject(1),
            isOpen: false,
            unreadCount: 0,
            threads: null,
        }
    },

    computed: {
        ready() {
            return this.threads !== null
        },

        isBrand() {
            const user = UserProvider.authUser()
            return user && user.user_type === 'brand'
        },
    },

    created() {
        this.subscribe(this.isOpenStream, isOpen => {
            this.onToggledOpen(isOpen)
            this.isOpen = isOpen
        })
        this.subscribe(ChatProvider.newMessages(), this.onMessageReceived)
        this.subscribe(ChatProvider.threads(), threads => (this.threads = threads))
        this.subscribe(ChatProvider.unread(), unread => (this.unreadCount = unread.length))

        this.onPageVisit(() => {
            const hash = window.location.hash

            if (hash.startsWith('#/messages/')) {
                this.openChat(hash.replace('#/messages/', ''))
            }
        })
    },

    methods: {
        close() {
            this.isOpenStream.next(false)
        },

        open() {
            this.isOpenStream.next(true)
        },

        getDate(item) {
            return item.latest_message !== null ? item.latest_message.created_at : item.created_at
        },

        getExcerpt(item) {
            return item.latest_message !== null ? item.latest_message.excerpt : ''
        },

        getSaveStateConfig() {
            return {
                autoSave: true,
                // ChatThreadNav is rendered on every page. We need more specific
                // cache key for correct restoration of currentModal state
                cacheKey: window.location.href + this.getCacheKey(),
                saveProperties: ['currentModal', 'currentModalParams'],
            }
        },

        getTitle(item) {
            let title = item.name

            return title
        },

        getInfluencerName(item) {
            const participant = item.participants.find(
                p => p.user && p.user.id === item.subject.influencer_id
            )

            return participant ? participant.user.name : 'Ukendt'
        },

        getTitleCombined(item) {
            const influencerName = this.getInfluencerName(item)
            let title = `${influencerName} | ${item.name}`
            return title
        },

        openChat(threadId) {
            this.close()
            this.openModal('chat', { threadId })
        },

        onMessageReceived() {
            ChatProvider.threads()
                .pipe(skip(1))
                .pipe(take(1))
                .subscribe(threads => {
                    if (!this.isOpen) {
                        this.showPopover(threads[0])
                    }
                })
        },

        onToggledOpen(isOpen) {
            if (isOpen) {
                this.destroyPopovers()
            }
        },

        showPopover(thread) {
            this.popover(this.$el, 'Ny besked modtaget fra ' + thread.participants[0].user.name, {
                placement: 'bottom',
                container: '.MainMenu',
            })
        },
    },
}
</script>
